import { render } from "./SkeletonStatCard.vue?vue&type=template&id=d6a9bb8a"
import script from "./SkeletonStatCard.vue?vue&type=script&lang=js"
export * from "./SkeletonStatCard.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__